import { EmojiEvents, Security, ThumbUp, Verified } from "@mui/icons-material";
import { Box, Grid, Stack, Typography, useTheme } from "@mui/material";
import React from "react";

export default function WhyAdin() {
  const theme = useTheme();

  const trustPoints = [
    {
      icon: <Verified sx={{ fontSize: 32 }} />,
      title: "مجوز رسمی",
      desc: "دارای مجوز از وزارت ورزش و جوانان",
      color: "#2196F3",
    },
    {
      icon: <EmojiEvents sx={{ fontSize: 32 }} />,
      title: "پیشرو در صنعت",
      desc: "نوآورترین پلتفرم ورزشی ایران",
      color: "#FF9800",
    },
    {
      icon: <Security sx={{ fontSize: 32 }} />,
      title: "امنیت تضمینی",
      desc: "حفظ حریم خصوصی کاربران",
      color: "#4CAF50",
    },
    {
      icon: <ThumbUp sx={{ fontSize: 32 }} />,
      title: "رضایت ۹۸٪",
      desc: "کاربران از ما راضی هستند",
      color: "#E91E63",
    },
  ];
  const trustItems = trustPoints.map((point, index) => (
    <Grid size={{ xs: 6, md: 3 }} key={index}>
      <Box
        sx={{
          textAlign: "center",
          p: 2.5,
          m: 1,
          borderRadius: 4,
          bgcolor: `${point?.color}05`,
          border: `1px solid ${theme.palette.divider}`,
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          cursor: "pointer",
          "&:hover": {
            transform: "translateY(-6px)",
            borderColor: point.color,
            bgcolor: `${point.color}08`,
            boxShadow: `0 4px 20px ${point.color}20`,
          },
        }}
      >
        <Box
          sx={{
            color: point.color,
            mb: 1.5,
            transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            "&:hover": {
              transform: "scale(1.05)",
            },
            "& svg": {
              fontSize: 40,
            },
          }}
        >
          {point.icon}
        </Box>
        <Typography sx={{ fontWeight: 700, fontSize: "1rem", mb: 0.5 }}>
          {point.title}
        </Typography>
        <Typography sx={{ fontSize: "0.75rem", color: "text.secondary" }}>
          {point.desc}
        </Typography>
      </Box>
    </Grid>
  ));
  return (
    <Stack sx={{ py: "2rem" }}>
      <Box sx={{ textAlign: "center", mb: 2 }}>
        <Typography sx={{ fontSize: "1.5rem", fontWeight: 700, mb: 1 }}>
          چرا آدین زون؟
        </Typography>
        <Typography
          sx={{
            fontSize: "0.85rem",
            color: "text.secondary",
            maxWidth: 500,
            mx: "auto",
          }}
        >
          به چند دلیل ساده، انتخابی هوشمندانه
        </Typography>
      </Box>

      <Grid container sx={{ mb: 8 }}>
        {trustItems}
      </Grid>
    </Stack>
  );
}
